import * as React from 'react';
import * as PropTypes from 'prop-types';
import { classNames } from '@progress/kendo-react-common';
import { avatarType, avatarShape } from './interfaces/Enums';
var Avatar = function (props) {
    return (React.createElement("div", { style: props.style, className: classNames('k-avatar', "k-avatar-" + props.shape, "k-avatar-" + props.type, props.className) }, props.children));
};
Avatar.propTypes = {
    className: PropTypes.string,
    shape: PropTypes.oneOf(['circle', 'square', 'rounded']),
    type: PropTypes.oneOf(['initials', 'image', 'icon'])
};
Avatar.defaultProps = {
    type: avatarType.INITIALS,
    shape: avatarShape.SQUARE
};
export default Avatar;
//# sourceMappingURL=Avatar.js.map